import React from 'react';
import PropTypes from 'prop-types';

import { withTheme } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconDownloadCloud = ({ theme, ...otherProps }) => (
  <SvgIcon {...otherProps} viewBox="0 0 88.829285 74.252708">
    <path fill={theme.palette.primary[500]} transform="matrix(-1 0 0 1 89.032 0)" d="m72.038 22.606c-1.219-12.667-11.765-22.606-24.746-22.606-10.049 0-18.65 5.963-22.614 14.519-1.1965-0.38042-2.4374-0.63844-3.7561-0.63844-6.8987 0-12.492 5.5964-12.492 12.492 0 1.3715 0.27481 2.668 0.683 3.8978-5.369 3.1289-9.0111 8.8725-9.0111 15.529 0 9.9664 8.0784 18.045 18.045 18.045v0.0056h49.969v-0.0056c11.501 0 20.815-9.3195 20.815-20.821-0.0028-10.15-7.2734-18.58-16.893-20.418" />
    <path fill={theme.palette.primary[150]} transform="matrix(-1,0,0,1,72,0)" d="m53.351 48.251c-0.769-7.985-7.417-14.251-15.601-14.251-6.335 0-11.757 3.759-14.256 9.153-0.75431-0.23982-1.5366-0.40249-2.3679-0.40249-4.3491 0-7.8755 3.5281-7.8755 7.8754 0 0.86462 0.17324 1.682 0.43058 2.4572-3.386 1.973-5.682 5.594-5.682 9.79 0 6.283 5.0928 11.376 11.376 11.376v0.0036h31.502v-0.0036c7.25 0 13.122-5.875 13.122-13.126-0.002-6.398-4.585-11.713-10.649-12.872" />
    <path fill={theme.palette.common.white} d="m54.871 40.308-9.5646 9.4279c-1.9302 1.9351-3.119 1.872-4.9936 0l-9.564-9.428c-1.371-2.2387-0.25041-4.0702 2.4968-4.0702h4.5055v-10.149c0-1.3988 1.1333-2.5347 2.5296-2.5347h5.0593c1.3988 0 2.5296 1.1359 2.5296 2.5347v10.149h4.5004c2.7472 0 3.8754 1.8315 2.5018 4.0702" />
  </SvgIcon>
);

IconDownloadCloud.propTypes = {
  theme: PropTypes.shape({
    palette: PropTypes.shape({
      primary: PropTypes.shape({
        150: PropTypes.string.isRequired,
        500: PropTypes.string.isRequired,
      }).isRequired,
      common: PropTypes.shape({
        white: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

export default withTheme()(IconDownloadCloud);



// WEBPACK FOOTER //
// ./src/components/icons/IconDownloadCloud.js